<template>
  <div v-if="current">
    
    <v-card width="100%">
      <v-card-title>Dados do registro</v-card-title>
      <v-card-text>
        <v-form>
          <div class="row">
            <div class="col-md-4 col-sm-1">
              <v-text-field
                label="Contato"
                v-model="current.contact"
                outlined
                dense
                readonly
                append-icon="mdi-speedometer"
                @click:append="dialog_nps = true"
              ></v-text-field>
            </div>
            <div class="col-md-4 col-sm-1">
              <v-text-field
                label="Nome"
                v-model="current.name"
                outlined
                dense
                readonly
              ></v-text-field>
            </div>
            <div class="col-md-4 col-sm-1">
              <v-text-field
                label="Avatar"
                v-model="current.avatar"
                outlined
                dense
                readonly
              ></v-text-field>
            </div>
            <div class="col-md-12 col-sm-1">
              <v-text-field
                label="Endereço"
                v-model="current.address"
                outlined
                dense
                readonly
              ></v-text-field>
            </div>
          </div>
        </v-form>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialog_nps" max-width="700px">
      <v-card width="100%" v-if="nps">
        <v-card-title>NPS</v-card-title>
        <v-card-text>
          <v-simple-table>
            <thead>
              <tr>
                <th>Data/Hora</th>
                <th>Parceiro recebido</th>
                <th>Parceiro conhecido</th>
                <th>Nota recebida</th>
                <th>Nota reconhecida</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in nps" :key="item.id">
                <td>{{ item.created | formatDate }} {{ item.created | formatTime}}</td>
                <td>{{ item.partnerReceived }}</td>
                <td>{{ item.partnerKnownName }}</td>
                <td>{{ item.scoreReceived }}</td>
                <td>{{ item.scoreKnown }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    
  </div>
</template>

<script>
import api from "../../api/index.js";
export default {
  data: () => ({
    current: null,
    nps: [],
    dialog_nps: false,
  }),
  created: function () {
    this.load();
  },
  methods: {
    loadNPS: function(){
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/nps/contact/" + this.current.contact, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.nps = response.data;
        })
        .catch(function () {
          console.log("load fail");
        });
    },
    load: function () {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/lead/" + this.$route.params.id, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.current = response.data;
          me.loadNPS();
        })
        .catch(function () {
          console.log("load fail");
        });
    },
  },
};
</script>